// DOM Ready
function documentReady(fn) {
    if (document.readyState !== 'loading') {
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
}

// Countdown Timer
const countdownTimer = {
    showTimer: function () {
        const offHours = document.querySelectorAll('.nav-user-shipping.off-hours');
        const offHoursMobile = document.querySelectorAll('.nav-user-shipping-mobile.off-hours');
        const onHours = document.querySelectorAll('.nav-user-shipping.on-hours');
        const onHoursMobile = document.querySelectorAll('.nav-user-shipping-mobile.on-hours');
        offHours.forEach(element => {
            element.style.display = 'none';
        });
        offHoursMobile.forEach(element => {
            element.style.display = 'none';
        });
        onHours.forEach(element => {
            element.style.display = 'flex';
        });
        onHoursMobile.forEach(element => {
            element.style.display = 'flex';
        });
        console.log('show timer');
    },
    hideTimer: function () {
        const offHours = document.querySelectorAll('.nav-user-shipping.off-hours');
        const offHoursMobile = document.querySelectorAll('.nav-user-shipping-mobile.off-hours');
        const onHours = document.querySelectorAll('.nav-user-shipping.on-hours');
        const onHoursMobile = document.querySelectorAll('.nav-user-shipping-mobile.on-hours');
        onHours.forEach(element => {
            element.style.display = 'none';
        });
        onHoursMobile.forEach(element => {
            element.style.display = 'none';
        });
        offHours.forEach(element => {
            element.style.display = 'flex';
        });
        offHoursMobile.forEach(element => {
            element.style.display = 'flex';
        });
        console.log('hide timer');
    },
    isHoliday: function(){
        const timeZone = 'America/New_York';
        const now = new Date().toLocaleString('en-US', { timeZone });

        
        
        

        

        // List of dates to check against
        const datesToCheck = [
            '12/24/2023','12/25/2023','12/31/2023','01/01/2024','01/15/2024','05/27/2024','07/03/2024','07/04/2024','09/02/2024','11/27/2024','11/28/2024','11/29/2024','12/24/2024','12/25/2024','01/01/2024'
        ];

        console.log('datesToCheck', '12/24/2023','12/25/2023','12/31/2023','01/01/2024','01/15/2024','05/27/2024','07/03/2024','07/04/2024','09/02/2024','11/27/2024','11/28/2024','11/29/2024','12/24/2024','12/25/2024','01/01/2024');

        // Convert today's date to the format MM/DD/YYYY
        const formattedDate = new Date(now).toLocaleDateString('en-US', {
            timeZone,
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        });

        // Check if today's date is in the list
        return datesToCheck.includes(formattedDate);
    },
    isWeekDay: function(){
        const currentDate = new Date();
        const currentDay = currentDate.getDay(); // 0 (Sunday) to 6 (Saturday)

        // Check the Holiday schedule first
        if (countdownTimer.isHoliday()){
            return false;
        }

        // Check if the current day is Monday (1) through Thursday (4)
        return currentDay >= 1 && currentDay <= 4;
    },
    isBetween9AM3PM_EST: function(){
        const timeZone = 'America/New_York';
        const now = new Date();
        const currentSecond = now.getSeconds();
        const options = { timeZoneName: 'short' };

        const currentTime = new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: false, timeZone });
        const currentHour = currentTime.split(':')[0];
        const currentMinute = currentTime.split(':')[1];

        // Check if the current time is between 9:00 AM and 3:00 PM in EST
        if (currentHour >= 9 && currentHour < 15) {
            // Calculate remaining time until 3:00 PM
            const remainingHours = 14 - currentHour;
            const remainingMinutes = 60 - currentMinute;
            const remainingSeconds = 59 - currentSecond;
            const remainingTime = `${remainingHours}:${remainingMinutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
            return `${remainingTime}`;
        } else {
            return false;
        }
    },
    updateTime: function(remainingTime){
        if (!remainingTime) {
          countdownTimer.hideTimer();
          window.clearInterval(window.timerInterval);
          return;
        }
        const countdownTimerEl = document.querySelectorAll('.shipping-notice .countdown-timer');
        countdownTimerEl.forEach(element => {
            element.innerHTML = remainingTime;
        })
    }
}

// Subscription Page: Variant Selector Switch for ATC
const subscriptionVariant = () => {
    const subscriptionSelect = document.querySelectorAll('.subscription-select');

    subscriptionSelect.forEach(select => {
        select.addEventListener('change', function () {
            const selected = this.options[this.selectedIndex];
            const price = selected.dataset.price;
            select.parentNode.querySelector('.product-variant-id').value = selected.value;
            select.parentNode.parentNode.querySelector('.product-grid-price div').innerHTML = '$' + parseInt(price / 100).toFixed(2);
        });

    });
}

// Gifts Page: Variant Selector Switch for ATC
const giftsVariant = () => {
    const productGridSelect = document.querySelectorAll('.product-grid-select');

    productGridSelect.forEach(select => {
        select.addEventListener('change', function () {
            const selected = this.options[this.selectedIndex];
            const price = selected.dataset.price;
            select.parentNode.querySelector('.product-variant-id').value = selected.value;
            if (select.parentNode.parentNode.querySelector('.product-grid-price div')){
                select.parentNode.parentNode.querySelector('.product-grid-price div').innerHTML = '$' +  price;
            }
        });

    });
}

// SmartCart trigger
//const smartCartTrigger = () => {
//    const goCartTriggers = document.querySelectorAll('.go-cart__trigger');
//    goCartTriggers.forEach(trigger => {
//        trigger.addEventListener('click', () => {
//            Rebuy.SmartCart.show();
//        });
//    });
//}

// Mega Menu Variant Selector and Add to Cart
const megaMenuVariant = () => {
    const productSelect = document.querySelector('.mega-menu-inner #productSelect');
    const productVariantIdContainer = document.querySelector('.mega-menu-inner .product-variant-id');

    productSelect.addEventListener('change', function () {
        productVariantIdContainer.value = productSelect.value;
    });
}

// Collection Page: Variant Select Price Change
const collectionPageVariants = () => {
    const productSelect = document.querySelectorAll('.component-collection #productSelect');

    productSelect.forEach(select => {
        const productPriceContainerSale = select.parentNode.parentNode.querySelector('.grid-sale-prices');
        const productPriceContainer = select.parentNode.parentNode.querySelector('.product-grid-price');

        if (productPriceContainerSale){
            select.addEventListener('change', function () {
                productPriceContainerSale.innerHTML = '$' + select.options[select.selectedIndex].dataset.price;
            });
        }
        if (productPriceContainer){
            select.addEventListener('change', function () {
                productPriceContainer.innerHTML = '$' + select.options[select.selectedIndex].dataset.price;
            });
        }

        select.addEventListener('change', function () {
            const selected = this.options[this.selectedIndex];
            select.parentNode.querySelector('.product-variant-id').value = selected.value;
        });
    });
}

// Collection Carousel: Variant Select Price Change
const collectionCarouselVariants = () => {
    const productSelect = document.querySelectorAll('.component-collection-carousel #productSelect');

    productSelect.forEach(select => {
        const productPriceContainer = select.parentNode.parentNode.parentNode.querySelector('.product-grid-price .comparing-prices');

        select.addEventListener('change', function () {
            console.log('price', select.options[select.selectedIndex].dataset.price);
            productPriceContainer.innerHTML = '$' + select.options[select.selectedIndex].dataset.price;
        });
    });
}

// Cart Page: Quantity Increment
const cartPageQuantityIncrements = () => {
    const plusButtons = document.querySelectorAll('.cart-product-bottom .plus');
    const minusButtons = document.querySelectorAll('.cart-product-bottom .minus');

    // Add a click event listener to each '.plus' element
    plusButtons.forEach(function (button) {
        button.addEventListener('click', function () {
            // Find the parent element containing '.quantity-selector'
            const quantitySelector = button.parentNode.querySelector('.quantity-selector');

            // Get the current value and increment it by 1
            const currentValue = parseInt(quantitySelector.value, 10);
            if (!isNaN(currentValue)) {
                quantitySelector.value = currentValue + 1;
            }
        });
    });

    // Add a click event listener to each '.minus' element
    minusButtons.forEach(function (button) {
        button.addEventListener('click', function () {
            // Find the parent element containing '.quantity-selector'
            const quantitySelector = button.parentNode.querySelector('.quantity-selector');

            // Get the current value and decrement it by 1 if it's greater than 0
            const currentValue = parseInt(quantitySelector.value, 10);
            if (!isNaN(currentValue) && currentValue > 1) {
                quantitySelector.value = currentValue - 1;
            }
        });
    });

}

// Toggle Search Bar
const toggleSearchBar = () => {
    $(document).on('click', '.js-show-search-now', function(){
        console.log('click');
        const navElement = document.querySelector('nav.nav');
        const searchBarElement = document.querySelector('.search-bar');
        navElement.classList.toggle('closed');
        searchBarElement.classList.toggle('closed');
    });
}

// Account - Yotpo My Rewards
const yotpoMyRewards = () => {
    function addYotpoCheckoutLine(){
        const yotpoWidget = document.querySelector('.yotpo-widget-my-rewards-widget');
        const descriptionBox = document.querySelector('.yotpo-widget-my-rewards-widget .yotpo-description');
        const redeemText = 'Proceed to checkout to redeem your points.';
        const redeemLine = `<div class="yotpo-redeem-checkout body1">${redeemText}</div>`;

        if (yotpoWidget && descriptionBox) {
            descriptionBox.insertAdjacentHTML('beforeend', redeemLine);
        }
    }
    addYotpoCheckoutLine();


    document.addEventListener('click', function(event) {
        const yotpoRedeemCheckout = document.querySelector('.yotpo-redeem-checkout');

        if (!yotpoRedeemCheckout) {
            addYotpoCheckoutLine();
        }
    });

}

// PDP Scroll to Reviews
const pdpScrollToReviews = () => {
    const bottomlineElements = document.querySelectorAll('.bottomLine');

    function scrollToElement(targetElement) {
        window.scrollTo({
            behavior: 'smooth',
            top: targetElement.offsetTop
        });
    }

    bottomlineElements.forEach(function (element) {
        element.addEventListener('click', function () {
            const targetElement = document.getElementById('yotpo-reviews-main-widget');
            scrollToElement(targetElement);
        });
    });

}

documentReady(function () {
    // If it is Monday through Thursday
    if (countdownTimer.isWeekDay()) {
        const remainingTime = countdownTimer.isBetween9AM3PM_EST();

        // If this is between 9:00 AM and 3:00 PM EST
        if (remainingTime !== false) {
            countdownTimer.updateTime(countdownTimer.isBetween9AM3PM_EST());
            window.timerInterval  = setInterval(() => countdownTimer.updateTime(countdownTimer.isBetween9AM3PM_EST()), 1000);
            countdownTimer.showTimer();
        }
        // Not between 9:00 AM and 3:00 PM EST
        else {
            countdownTimer.hideTimer();
        }
    }
    // Not Monday through Thursday
    else {
        countdownTimer.hideTimer();
    }

    subscriptionVariant();
    //smartCartTrigger();
    megaMenuVariant();
    collectionPageVariants();
    collectionCarouselVariants();
    cartPageQuantityIncrements();
    toggleSearchBar();
    giftsVariant();
    pdpScrollToReviews();
    setTimeout(function(){
        yotpoMyRewards();
    },2300);
});


// Hamburger Animation
$(".hamburger").click(function () {
    $(this).toggleClass("is-active");
});

$(".js-nav-control").click(function () {
    $('body').toggleClass('open');
});


// Smooth Scroll Animation


// SEARCH
$('.user-icons').on("click", function (e) {
    $('#search-pop').hide();
});


/*
$("body").on("click", '.js-show-search, .search-close', function (e) {
    $('.search-close').css('padding-top', $('.header').height() + 100 + 'px')
    if ($('#search-pop').is(":visible") && $(window).scrollTop() == 0) {
        $(".index .header").removeClass('header_bar');
        $('.index .header .logo img').attr('src', $('.logo img').data('src-home'));
    } else {
        $(".index .header").addClass('header_bar');
        $('.index .header .logo img').attr('src', $('.logo img').data('src'));
    }

    $('#search-pop').fadeToggle('fast').find('input').focus();
    e.stopPropagation();
    e.preventDefault();
});

 */

// Collection Carousel
$(document).ready(function () {
    var collectionCarousel = $(".collection-carousel");
    collectionCarousel.each(function () {
        $(this).slick({
            slidesToShow: 4,
            slidesToScroll: 4,
            arrows: true,
            dots: false,
            prevArrow: '.component-collection-carousel .carousel-arrows .carousel-prev',
            nextArrow: '.component-collection-carousel .carousel-arrows .carousel-next',
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        arrows: true,
                    }
                },
                {
                    breakpoint: 600,
                    centerMode: true,
                    centerPadding: '60px',
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: false,
                        arrows: true,
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        centerMode: true,
                        centerPadding: '40px',
                        slidesToShow: 1,
                        arrows: true,
                        dots: false,
                    }
                }
            ]
        });
    });
});

// Testimonial Carousel
$(document).ready(function () {
    var collectionCarousel = $(".testimonial-carousel");
    collectionCarousel.each(function () {
        $(this).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            centerMode: true,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            centerPadding: '220px',
            prevArrow: '.component-testimonial-carousel .carousel-arrows .carousel-prev',
            nextArrow: '.component-testimonial-carousel .carousel-arrows .carousel-next',
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerMode: true,
                        centerPadding: '160px'
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerMode: true,
                        centerPadding: '0px',
                        arrows: true,
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        centerMode: false,
                        centerPadding: '40px',
                        slidesToShow: 1,
                        arrows: true,
                        dots: false
                    }
                }
            ]
        });
    });
});



$('.js-blog-carousel').slick({
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 2,
            }
        },
        {
            breakpoint: 600,
            centerMode: true,
            centerPadding: '60px',
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                arrows: false,

            }
        }
    ]

});




// PDP CAROUSEL WITH THUMBS
$('.js-slider-primary').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
      arrows: false,
    fade: true,
    infinite: true,
    asNavFor: '.js-slider-thumbs'
});
$('.js-slider-thumbs').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.js-slider-primary',
    dots: false,
    centerMode: false,
    focusOnSelect: true,
    infinite: true,
    variableWidth: false,
    arrows: true,
    prevArrow: '.product-thumbs .carousel-prev',
    nextArrow: '.product-thumbs .carousel-next',
});

// CHANGE IMAGE WITH VARIANT CHANGE
(function (window, $) {
    $(document).ready(function () {
        $('body')
            .on('change', '#productSelect', function (event) {
                // Update Price
                var selected = this.options[this.selectedIndex],
                    variantPrice = selected.dataset.price;

                $('#productPrice').text('$' + variantPrice);

                /** Update image Slider */
                var variantImage = selected.dataset.image;
                var position = -1;

                $('.product-thumbs .single-thumb').each(function () {
                    if ($(this).data('image') == variantImage) {
                        position = parseInt($(this).data('slick-index'));
                        return;
                    }
                });

                if (position != -1) {
                    $('.product-thumbs').find('.js-slider-thumbs').slick('slickGoTo', position);
                }


                /** Update Nutritions table tab content */
                if (this.options.length > 1 && window.product_variants !== undefined) {
                    product_variants.forEach((variant_meta) => {
                        if (variant_meta.id == selected.value) {
                            for (const [key, value] of Object.entries(variant_meta)) {
                                $(`.js-meta-${key}`).empty().html(value);
                            }
                        }
                    });
                }
            })
    })
})(window, jQuery);


// Footer Nav

function resizeHandler() {
    console.log("window resized");

    if ($(window).width() < 990) {
        console.log("window small than 600");

        $('.footer-nav ul').hide();
        $('.footer-nav ul').slideUp(200);
    } else {
        $('.footer-nav ul').show();
        $('.footer-nav-header').removeClass("expanded");
    }
}

resizeHandler();

$(document).ready(resizeHandler);

$('body').on('click', '.footer-nav-header', function () {
    if ($(window).width() < 990) {
        $(this).next().slideToggle(200);
        $(this).toggleClass("expanded");
        console.log('footer tap');
    }
});

// Recipe Carousel
$(document).ready(function () {
    var recipeCarousel = $(".js-featured-recipe-carousel");
    recipeCarousel.each(function () {
        $(this).slick({
            slidesToShow: 4,
            slidesToScroll: 4,
            arrows: true,
            dots: false,
            prevArrow: '.carousel-arrows .carousel-prev',
            nextArrow: '.carousel-arrows .carousel-next',
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        arrows: true,
                    }
                },
                {
                    breakpoint: 600,
                    centerMode: true,
                    centerPadding: '60px',
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: false,
                        arrows: true,
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        centerMode: true,
                        centerPadding: '40px',
                        slidesToShow: 1,
                        arrows: true,
                        dots: false,
                    }
                }
            ]
        });
    });
});

// Klaviyo Accessibility Fix
window.addEventListener('klaviyoForms', function (e) {
    if (e.detail.type == 'embedOpen') {
        setTimeout(function(){
            const element = document.querySelector('.kl-private-reset-css-Xuajs1');
            if (element) {
                console.log('element', true);
                element.setAttribute('aria-modal', 'true');
                element.setAttribute('role', 'dialog');
            }

            const emailElement = document.getElementById('email_687681');
            if (emailElement) {
                console.log('element', true);
                emailElement.setAttribute('aria-required', 'true');
            }

            const emailInputElement = document.getElementById('email_79981092');
            if (emailInputElement) {
                console.log('element', true);
                emailInputElement.setAttribute('aria-required', 'true');
            }
        },400);
    }
});

// Accessibility Fixes for ReBuy Cart
document.addEventListener('rebuy:cart.ready', (event) => {
    console.log('rebuy:cart.ready event', event.detail);
    if (document.querySelector('.rebuy-cart__flyout-subtotal-label span')){
        document.querySelector('.rebuy-cart__flyout-subtotal-label span').setAttribute('role', 'heading');
    }

});


// Trusted Site Badge Accessibility Fix
function trustedSiteBadge() {
    const maxAttempts = 5;
    let attempts = 0;

    const intervalId = setInterval(function () {
        const element = document.getElementById('trustedsite-tm-image');

        if (element) {
            element.setAttribute('aria-label', 'Trusted Site Badge');
            clearInterval(intervalId);
        }

        attempts++;

        if (attempts >= maxAttempts) {
            clearInterval(intervalId);
        }
    }, 1000);
}
document.addEventListener('DOMContentLoaded', trustedSiteBadge);

// Fix Multiple Shipping Address Interaction with ReBuy
document.addEventListener('DOMContentLoaded', function() {
    if (document.getElementById('gsMultishippingPage') && window.location.href === "https://www.alaskankingcrab.com/a/gs/cart/") {
        var style = document.createElement('style');
        style.type = 'text/css';

        var css = 'body #rebuy-cart { display: none !important; } body.rebuy-modal-visible { overflow: visible !important; }';

        if (style.styleSheet) {
            style.styleSheet.cssText = css; // Support for IE
        } else {
            style.appendChild(document.createTextNode(css)); // Support for other browsers
        }

        document.head.appendChild(style);
    }
});

// Mega Menu Product Compare at Price
document.addEventListener('DOMContentLoaded', function() {
    const megaProductSelect = document.querySelector('.mega-product #productSelect');

    if (megaProductSelect) {
        megaProductSelect.addEventListener('change', function() {
            const selectedOption = this.options[this.selectedIndex];

            if (selectedOption.getAttribute('data-index') === '3') {
                const compareAtPrice = selectedOption.getAttribute('data-compare-at-price');
                const compareAtPriceDisplay = document.querySelector('.mega-product .compare-at-price-display');

                if (compareAtPriceDisplay) {
                    compareAtPriceDisplay.innerText = '$' + compareAtPrice;
                    compareAtPriceDisplay.classList.remove('d-none');
                }
            }
            else {
                document.querySelector('.mega-product .compare-at-price-display').classList.add('d-none');
            }
        });
    }
});

// Display outline only when user is using the tab key
function checkTabPress(e) {
    "use strict";
    e = e || event;
    if (e.keyCode == 9) {
        document.body.classList.remove('u-no-focus-outline');
    }
}

document.addEventListener('DOMContentLoaded', function() {
    const body = document.querySelector('body');
    body.classList.add('u-no-focus-outline');
    body.addEventListener('keyup', checkTabPress);
});

/** Rebuy Smart Cart **/

/* ReBuy Widget Upsell Image Background */
const upSellImageBackground = function() {
    const images = document.querySelectorAll('.rebuy-cart__flyout-recommendations .rebuy-product-image img');
    images.forEach(function(img) {
        const src = img.getAttribute('src');
        const productMedia = img.parentNode.parentNode.parentNode.querySelector('.rebuy-product-media');

        if (productMedia) {
            productMedia.style.backgroundImage = `url('${src}')`;
        }
    });
}

/* On Mobile: Move Checkout Above Items */
const moveElementOnMobile = function() {
    const screenWidth = window.innerWidth;
    const subtotalActions = document.querySelector('.rebuy-cart__subtotal-actions');
    const flyoutContent = document.querySelector('.rebuy-cart__flyout-content');
}

document.addEventListener('rebuy:smartcart.show', (event) => {
    moveElementOnMobile();
    upSellImageBackground();
});

document.addEventListener('rebuy:cart.add', (event) => {
    let intervalId = setInterval(upSellImageBackground, 900);
    setTimeout(function() {
        clearInterval(intervalId);
    }, 25000);
});

// Open Klaviyo Sold Out Form
document.addEventListener('DOMContentLoaded', function() {
    function getQueryParam(param) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(param);
    }

    if (getQueryParam('oos') === '1') {
        let intervalCounter = 0;
        const maxIntervalChecks = 20;
        const checkInterval = 1000;

        const intervalId = setInterval(function() {
            const targetElement = document.getElementById('BIS_trigger');

            if (targetElement) {
                targetElement.click();
                clearInterval(intervalId);
            }
            intervalCounter++;

            if (intervalCounter >= maxIntervalChecks) {
                clearInterval(intervalId);
            }
        }, checkInterval);
    }
});
